// Encore Garage Door Systems — Upwardor subsidiary with its own portal
// deployment. Black chrome with the official logo gold (#CAA131).
const GOLD = "#CAA131";
const GOLD_RGB = "202, 161, 49";

const encore = {
  key: "encore",
  name: "Encore GDS",
  legalName: "Encore Garage Door Systems Inc.",
  title: "Encore GDS Customer Portal",
  supportEmail: "info@encoregds.ca",
  supportPhone: "613-955-7755",

  assets: {
    logo: "/assets/img/encore-logo-gold.svg",
    logoOnDark: "/assets/img/encore-logo-gold.svg",
    mark: "/assets/img/encore-mark.svg",
    favicon: "/assets/img/encore-fav.svg",
    loader: "/assets/img/encore-mark.svg",
    loaderPulse: true,
    manifest: "/manifest.encore.json",
    icons: {
      "enq-one.svg": "/assets/brands/encore/enq-one.svg",
      "enq-two.svg": "/assets/brands/encore/enq-two.svg",
      "usero-blue.svg": "/assets/brands/encore/usero-blue.svg",
    },
  },

  fonts: ["https://fonts.googleapis.com/css2?family=Marcellus&display=swap"],
  antd: { token: { colorPrimary: GOLD } },
  dashboard: "showroom",

  features: {
    // Encore's Business Central has no bulk-panel customer flags (not adopted).
    bulkPanels: false,
    // No feedback-survey banner on Encore's dashboard (Upwardor only for now).
    customerSurvey: false,
  },

  theme: {
    accent: GOLD,
    accentText: "#8C6D1F", // bronze: readable gold on white
    accentHover: "#AD8A2A",
    accentDeep: "#AD8A2A",
    accentLight: "#E5C877", // gold highlight on black chrome
    onAccent: "#1A1A1A",
    secondary: "#AD8A2A",
    secondaryAlt: GOLD,
    tabActive: "#8C6D1F",
    link: "#8C6D1F",
    badgeBg: "#F5EBD3",
    badgeText: "#8C6D1F",
    pillBg: "#F5EBD3",
    inputIconBg: `rgba(${GOLD_RGB}, 0.10)`,
    heroFrom: "#0B0B0B",
    fontDisplay: "'Marcellus', Georgia, serif",
    markUrl: "url(/assets/img/encore-mark.svg)",

    headerBg: "#0B0B0B",
    headerBorder: `rgba(${GOLD_RGB}, 0.25)`,

    navBg: "#0B0B0B",
    navBorder: `1px solid rgba(${GOLD_RGB}, 0.2)`,
    navLink: "#EDEDE8",
    navSubLink: "#C9C6BB",
    navText: "#EDEDE8",
    navSubText: "#C9C6BB",
    navIcon: "#B8B4A6",
    navLabel: "#B8B4A6",
    navDot: "#B8B4A6",
    navActiveBg: GOLD,
    navActiveText: "#1A1A1A",
    navHoverBg: `rgba(${GOLD_RGB}, 0.15)`,
    navHoverText: "#E5C877",
    navSubActiveText: "#E5C877",
    navSubActiveBg: `rgba(${GOLD_RGB}, 0.15)`,
    navColSideHoverText: "#E5C877",
    navColSideHoverBg: `rgba(${GOLD_RGB}, 0.15)`,
    navColSideHoverIcon: "#E5C877",
    navSidesActiveText: "#E5C877",
    navMaterialIcon: GOLD,

    authBgImage: "url(/assets/img/encore-logo-gold.svg)",
    authBgColor: "#0B0B0B",
    authBgSize: "min(420px, 60%) auto",
  },
};

export default encore;
